import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Typography,
} from '@mui/material';
import { useTranslation } from 'react-i18next';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

interface ConfirmDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  itemTitle?: string;
  itemType: 'event' | 'task';
}

const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  itemTitle,
  itemType,
}) => {
  const { t } = useTranslation();

  const handleConfirm = () => {
    onConfirm();
    onClose();
  };

  const dialogTitle =
    itemType === 'event'
      ? t('calendar.deleteEvent', 'Eliminar evento')
      : t('calendar.deleteTask', 'Eliminar tarea');

  const confirmationMessage =
    itemType === 'event'
      ? t('calendar.confirmDeleteEvent', '¿Estás seguro de que querés eliminar este evento?')
      : t('calendar.confirmDeleteTask', '¿Estás seguro de que querés eliminar esta tarea?');

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          //@ts-ignore
          backgroundColor: (theme) => theme.palette.background.panel,
        },
      }}
    >
      <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <WarningAmberIcon color="warning" />
        {dialogTitle}
      </DialogTitle>

      <DialogContent>
        <Typography variant="body2" sx={{ mb: 2 }}>
          {confirmationMessage}
        </Typography>

        {itemTitle && (
          <Box
            sx={{
              p: 1.5,
              bgcolor: 'action.hover',
              borderRadius: 1,
              borderLeft: 3,
              borderColor: 'warning.main',
            }}
          >
            <Typography variant="body2" sx={{ fontWeight: 500 }}>
              "{itemTitle}"
            </Typography>
          </Box>
        )}
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="outlined" color="inherit" sx={{ borderRadius: '8px' }}>
          {t('global.cancel', 'Cancelar')}
        </Button>
        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          sx={{ borderRadius: '8px' }}
        >
          {t('global.delete', 'Eliminar')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDeleteDialog;
